import { createDynamicSlice } from ".";
import { getVendorListThunk } from "../thunks/vendorsThunk";

export const vendorsSlice = createDynamicSlice({
  name: "vendors",
  thunk: getVendorListThunk,
  listMode: true,
  resetActionName: "resetVendors",
});

export const vendorsReducer = vendorsSlice.reducer;
export const { resetVendors } = vendorsSlice.actions;
